import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { formatCurrency } from "../../../../../../utils";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var Section = function Section(_ref) {
  var price = _ref.price,
    title = _ref.title,
    highlightColor = _ref.highlightColor;
  var hightLightGradient = {
    background: highlightColor
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx('section')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('header')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    size: "size5-r-l"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: cx('price'),
    style: _objectSpread({}, hightLightGradient)
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size3-m"
  }, formatCurrency(price))));
};